import { ADD_TO_CART,  GET_ALL_CART_DATA } from "./actionTypes";
import { endpoints } from '../../_config';
import { get, post } from "../../_services/apiService";
import { toast } from "react-toastify";

export const get_cart_Data = () => async (dispatch) => {


    const localCartData = JSON.parse(localStorage.getItem('lcart')) || [];
    dispatch({ type: GET_ALL_CART_DATA, payload: localCartData });
}

export const addToCart = (formData) => async (dispatch) => {

    try {


        const response = await get(endpoints.GetProductDetailById + "?pProductDetailId=" + formData.productId);//  getProductDetailById(formData.productId);
        if (response.isSuccess === 200) {
            const productDetails = response.data[0];


            const localCartData = JSON.parse(localStorage.getItem('lcart')) || [];

            const existingItem = localCartData.find(item => item.productId === productDetails.productId);


            if (existingItem) {
                existingItem.quantity += 1;
            } else {
                localCartData.push({ ...productDetails, quantity: 1 });
            }

            localStorage.setItem('lcart', JSON.stringify(localCartData));
            dispatch({ type: ADD_TO_CART, payload: { ...productDetails, quantity: 1 } });
            toast.success("Item added to local cart successfully");


        }


    } catch (error) {
        toast.error("Error occurred while fetching product details.");
    }
};

export const saveorder = (formData) => async (dispatch) => {
    try {

        if (formData.loginId > 0) {

            const responsecart = await post(endpoints.SaveProductOrder, formData)
            if (responsecart.isSuccess === 200) {
                localStorage.setItem("CartData", '');
            }
            localStorage.setItem("CartData", '');
        }


    } catch (error) {
        toast.error("Error occurred while fetching product details.");
    }
};


export const deleteItem = (item) => async (dispatch) => {
    const localCartData = JSON.parse(localStorage.getItem('lcart')) || [];
    const updatedCartData = localCartData.filter(cartItem => cartItem.productId !== item.productId);

    localStorage.setItem('lcart', JSON.stringify(updatedCartData));
    dispatch(get_cart_Data());
};